module.exports = __webpack_public_path__ + "static/media/ping.a9bf7e08.webp";